import { Site } from "@/Common/Models/Sites/ResponseModels/Site";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";

type Model = "Model";
type ParentSites = "ParentSites";
type IsOrganization = "IsOrganization";
type Title = "Title";
type Id = "Id";
type InfoLabel = "InfoLabel";

interface ISiteCreateModel {
    get(key: Id): string;
    set(key: Id, value: string): this;

    get(key: Model): Site;
    set(key: Model, value: Site): this;

    get(key: ParentSites): Immutable.List<SitesModel>;
    set(key: ParentSites, value: Immutable.List<SitesModel>): this;

    get(key: IsOrganization): boolean;
    set(key: IsOrganization, value: boolean): this;

    get(key: Title): string;
    set(key: Title, value: string): this;

    get(key: InfoLabel): string;
    set(key: InfoLabel, value: string): this;
}

class SiteCreateModel {
    public static getDefault(): any {
        return Immutable.fromJS({
            Id: "site_id_" + sessionStore.newId(),
            Model: new Site,
            ParentSites: [],
            IsOrganization: false,
            Title: "",
            InfoLabel: ""
        });
    }
}

export { ISiteCreateModel, SiteCreateModel };
